module.exports = __webpack_public_path__ + "static/img/touxi1.c599f7e3.webp";